module.exports = __webpack_public_path__ + "assets/29296015c60cb9c27d063a8d1a2e49c7.woff";